module.exports = __webpack_public_path__ + "static/media/5.34690fa5.png";